export default __webpack_public_path__ + "static/media/GetHelp_Report.d292ab82.svg";